import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {NumberUtil} from "base/utilities";

import {EntityViewPanel} from "base/entity";
import {SectionCard, SectionField} from "base/component/presentational";

import Box from "@mui/material/Box";
import {EezService} from "./EezService";

export const EezViewPanel = () => {
    const {id} = useParams();

    const [entityState, setEntityState] = useState(null);

    useEffect(() => {
        EezService.get(id).then(data => {
            setEntityState(data);
        });
    }, [id]);

    return (
        entityState && (
            <EntityViewPanel title="EEZ" showDetailButton={false}>
                <SectionCard title={`${entityState.id}`}>
                    <SectionField label="Country:" value={entityState.country} />
                    <SectionField
                        label="Area (km²):"
                        value={
                            <Box sx={{fontWeight: "bold"}}>
                                {NumberUtil.formatDecimal(entityState.area_km2)}
                            </Box>
                        }
                    />
                    <SectionField label="Political:" value={entityState.political} />
                    <SectionField label="Authority:" value={entityState.authority} />
                    <SectionField label="More Info:" value={entityState.more_info} />
                </SectionCard>
            </EntityViewPanel>
        )
    );
};
